import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { accountSelector } from '../store/shared/accountSlice';
import { reportNumberOfDeals } from '../analytics';
import { activeDealsSelector } from '../store/shared/activeDealsSlice';

export default function useAgreementAnalytics(): { sendData: () => void } {
  const { currentAccountId } = useSelector(accountSelector);
  const activeDeals = useSelector(activeDealsSelector);
  useEffect(() => {
    if (activeDeals.deals) {
      reportNumberOfDeals(currentAccountId, activeDeals.deals.length);
    }
  }, [activeDeals]);
  return {
    sendData: () => {
      setTimeout(() => {
        if (!activeDeals.deals) {
          return;
        }
        reportNumberOfDeals(currentAccountId, activeDeals.deals.length);
      }, 300);
    },
  };
}
